// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2QGkO","emails":"CreateEditClinics_emails__MnLny","emailTagLabel":"CreateEditClinics_emailTagLabel__3XwHa"};